import { Timestamp } from "firebase/firestore";

/**
 * Converte dados do React/Formik (Matrícula na Turma) para armazenamento no Firestore.
 */
export const enrollmentToFirestore = (data, tenantData, authUser) => {
    const idTenant = typeof tenantData === 'string' ? tenantData : tenantData?.id;
    if (!idTenant) throw new Error("ID do Tenant é obrigatório.");

    const payload = {
        idTenant,
        
        // Vínculos principais
        idMember: data.idMember,
        memberName: data.memberName,
        memberPhone: data.memberPhone,
        memberEmail: data.memberEmail,
        memberPhotoUrl: data.memberPhotoUrl || null,
        
        idClass: data.idClass,
        className: data.className,
        
        idMembership: data.idMembership,
        membershipName: data.membershipName,
        
        // Desnormalização da Turma
        idActivity: data.idActivity,
        activityName: data.activityName,
        idTeacher: data.idTeacher,
        teacherName: data.teacherName,
        teacherPhone: data.teacherPhone,
        teacherEmail: data.teacherEmail || null,
        teacherPhotoUrl: data.teacherPhotoUrl || null,
        idArea: data.idArea,
        area: data.area,
        
        // Identificação do tipo (Experimental, Reposição, Avulso, Regular)
        type: data.type,
        sessionDate: data.sessionDate, // Válido apenas para eventos isolados (experimental, avulsa)
        
        // Horário e Vaga
        startTime: data.startTime,
        endTime: data.endTime,
        weekDay: data.weekDay ?? null,
        spotNumber: data.spotNumber ?? null,
        
        // Vigência
        startDate: data.startDate,
        endDate: data.endDate,
        
        // Status atual
        status: data.status,
        
        observations: data.observations,

        // Tracking & Ciclo de Vida
        idConsultant: data.idConsultant || null,
        consultantName: data.consultantName || null,
        convertedToSale: data.convertedToSale || false,

        // Auditoria
        createdAt: data.id ? (data.createdAt || Timestamp.now()) : Timestamp.now(),
        updatedAt: Timestamp.now(),
        createdBy: (data.id && data.createdBy) ? data.createdBy : {
            uid: authUser?.uid || "system",
            name: authUser?.displayName || authUser?.fullName || authUser?.email || "Sistema"
        },
        updatedBy: {
            uid: authUser?.uid || "system",
            name: authUser?.displayName || authUser?.fullName || authUser?.email || "Sistema"
        }
    };

    // Remove campos undefined para evitar erros no setDoc
    Object.keys(payload).forEach(key => payload[key] === undefined && delete payload[key]);

    return payload;
};

/**
 * Mapeia os dados da Matrícula de Turma do Firestore para o React.
 */
export const enrollmentFromFirestore = (snapshot) => {
    if (!snapshot.exists()) return null;
    const data = snapshot.data();

    return {
        id: snapshot.id,
        ...data,
        createdAt: data.createdAt?.toDate ? data.createdAt.toDate() : data.createdAt,
        updatedAt: data.updatedAt?.toDate ? data.updatedAt.toDate() : data.updatedAt,
    };
};
